




























import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {CLICK_AND_COLLECT_CORTE_INGLES_ROUTES} from "@/constants/routes";
import ResendVerification from "@/views/Dialog/views/ResendVerification.vue";
import DroppoButton from "@/views/components/DroppoButton.vue";
import Dialog from "@/views/Dialog/Dialog.vue";
import ShipmentHelperText from '@/views/components/ShipmentHelperText.vue';

const userData = namespace("userData");

@Component({
  name: 'ClickAndCollectExplanation',
  components: {
    Dialog,
    ResendVerification,
    DroppoButton,
    ShipmentHelperText,
  },
})
export default class ClickAndCollectExplanation extends Vue {
  @userData.Getter('getDeliveryToken')
  private deliveryToken!: string;

  @userData.Getter('getFirstName')
  private firstName!: string;

  @userData.Getter('getOfficePhoneNumber')
  private getOfficePhoneNumber!: string;

  @userData.Getter('getOfficeEmail')
  private getOfficeEmail!: string;

  private next() {
    this.$router.push({name: CLICK_AND_COLLECT_CORTE_INGLES_ROUTES.FORM});
  }
}
